// Service to manage client recently viewed luxury pieces in localStorage

const STORAGE_KEY = "lhabilleur_recently_viewed";
const MAX_ITEMS = 8;

export const getRecentlyViewed = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.error("Error reading recently viewed pieces:", error);
    return [];
  }
};

export const addToRecentlyViewed = (product) => {
  if (!product || !product.id) return;

  try {
    const current = getRecentlyViewed();
    // Exclude existing instance of this item
    const filtered = current.filter((item) => item.id !== product.id);

    // Shape minimal clean representation to preserve localStorage space
    const summary = {
      id: product.id,
      productName: product.productName,
      price: product.price,
      imgUrl: product.imgUrl,
      category: product.category,
      material: product.material || "Artisanal",
      avgRating: product.avgRating || 4.8,
      viewedAt: Date.now(),
    };

    const updated = [summary, ...filtered].slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));

    // Dispatch a custom window event so open tabs/components re-render seamlessly
    window.dispatchEvent(new Event("recentlyViewedUpdated"));
  } catch (error) {
    console.error("Error saving recently viewed piece:", error);
  }
};

export const clearRecentlyViewed = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new Event("recentlyViewedUpdated"));
  } catch (error) {
    console.error("Error clearing recently viewed history:", error);
  }
};
